import React, {useEffect, useState} from "react";
import DragM from "dragm";
import "antd/dist/antd.css";
import { X } from "lucide-react";
import {useDispatch} from "react-redux";
import {InboxOperations} from "../../../redux/inbox";
import ButtonWithIcon from "../../atoms/button-with-icon";
import { PencilLine } from "lucide-react";
import { RegularButton, RegularButtonOutline } from "../../atoms";
import { tokens } from "../../../assets/tokens";
import i18n from '../../../assets/i18n'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {ModalDraggableStyled, TitleStyled} from "./styled";
import {split} from "lodash";
import moment from "moment";
import {manageQueriesWithPrefix, refetchQueriesByKeys} from "../../../api/mutations/mutationCallbacks";
import {QUERY_ACTIONS, QUERY_KEYS} from "../../../config/constants";
import {updateInterviewerNotes} from "../../../api";


const BuildTitle = ({ modalDom, title = '' }) => {


  const updateTransform = transformStr => {
    modalDom = document.getElementsByClassName("ant-modal-wrap" //modal的class是ant-modal-wrap
    )[0];
    modalDom.style.transform = transformStr;
  };

  useEffect( () => {
    // eslint-disable-next-line
    modalDom = document.getElementsByClassName("ant-modal-wrap" //modal的class是ant-modal-wrap
    )[0];

  }, []);

    return (
      <DragM updateTransform={ updateTransform }>
        <TitleStyled>{ title }</TitleStyled>
      </DragM>
    );

};

const DraggableModal = ({ id, interviewerNote = '', titleTab, setInterviewerNote, user, module = null, slug = null, className = null }) => {
  const dispatch = useDispatch();

  const [ visible, setVisible ] = useState( false );
  const [ auxNote, setAuxNote ] = useState( split(interviewerNote, '-*{}*-')[0]);

  const showModal = ( e ) => {

    e.preventDefault();
    setVisible( true );

    setTimeout(() => {
    document.querySelector("body").style.overflow = 'auto'

    }, 300)

  };

  const handleOk = ( e ) => {
    e.preventDefault();
    let note = `${ auxNote }-*{}*-${ user.name }-*{}*-${ moment().format('LTS') }-*{}*-${ moment().format('L') }`;
    if (className) {
      updateInterviewerNotes({id, note, class: className}, module).then(() => {
        manageQueriesWithPrefix([`${QUERY_KEYS.PERSON}:${id}`], QUERY_ACTIONS.REFETCH);
      }).catch(() => {

      });
    } else {
      dispatch(InboxOperations.updateInterviewerNotes( id, note, module ));
    }

    setInterviewerNote(note);

    if (module && slug) {
      setTimeout(() => {
        refetchQueriesByKeys([`${module}:${QUERY_KEYS.PROFILE}:${slug}`]);
      }, 1500)
    }
    setVisible( false );
  };

  const  handleCancel = ( ) => {
    setVisible( false );
  };

    const title = <BuildTitle title={titleTab} />;


    return (
      <>
          <ButtonWithIcon title={i18n.interviewerNotes.edit} Icon={<PencilLine />} onClick={ showModal }  />
        {/* Se queda en antd: es no modal (mask={false}, se sigue usando el perfil con las notas
            abiertas) y se arrastra desde el título, cosas que el Dialog de MUI no hace. Por eso
            replica a mano el aspecto de ActionDialog. */}
        <ModalDraggableStyled
          style={{minWidth: "750px"}}
          mask={ false }
          title={ title }
          visible={ visible }
          onCancel={ handleCancel }
          closeIcon={ <X size={20} color={tokens.color.text.primary} /> }
          footer={
            <>
              <RegularButtonOutline title={ i18n.dialog.decline } onClick={ handleCancel } type="button" />
              <RegularButton title={ i18n.dialog.save } onClick={ handleOk } type="button" />
            </>
          }
        >
          <CKEditor
            editor={ ClassicEditor }
            config={{
              toolbar: [ 'heading', '|', 'bold', 'italic','Underline', '|', 'undo', 'redo', '|', 'numberedList', 'bulletedList' ]
            } }
            data={ auxNote }
            onChange={ ( event, editor ) => {
              setAuxNote( editor.getData())
            } }
          />
        </ModalDraggableStyled>
      </>
    );

}


export default DraggableModal;